import { useContext } from "react";
import { DataControlerContext } from "context/DataControlerContext";
import { getTokenByActionAndResourceId } from "lib/utils";
import {
  Camera,
  DownloaderWebrtcAction,
  RecordDailyRsp,
} from "webrtc-player/common/downloader";
import { AuthContext } from "context/AuthContext";
import { ResDeviceType } from "webrtc-player/common/base";
import useWsSender from "lib/wsSenderHook";
import { SinglePcManagerContext } from "context/SinglePcManagerContext";

export default function usePlayBackRtcService() {
  const { getController } = useContext(SinglePcManagerContext);
  const { sendWsRequest } = useWsSender();
  const { user } = useContext(AuthContext);
  function getDailyRecord(
    nvrId: number,
    devId: string,
    orgId: number,
    camera: Camera,
    streamId: number,
    year: number,
    month: number,
  ) {
    return new Promise(
      async (resolve: (data: RecordDailyRsp) => void, reject) => {
        const [{ token }] = await getTokenByActionAndResourceId(
          [DownloaderWebrtcAction.RecordDaily],
          camera.id,
          user,
          ResDeviceType.CAMERA,
        );

        const controler = await getController(nvrId, devId, orgId);
        controler.recordDaily(
          {
            token,
            camera,
            streamId,
            year,
            month,
          },
          (err, data) => {
            if (err) {
              reject(err);
            } else {
              resolve(data);
            }
          },
        );
      },
    );
  }
  async function sendDeleteDownloadRequest(requests, orgId) {
    return sendWsRequest(
      "device.downloader.delete",
      {
        deviceDownloaderDelete: {
          requests: requests,
        },
      },
      { orgId },
    );
  }

  async function sendGetPlaybackRecordsRequest(
    id,
    streamId,
    startedAt,
    endedAt,
    orgId,
  ) {
    return sendWsRequest(
      "device.playback.get_records",
      {
        playbackGetRecords: {
          id,
          streamId,
          startedAt,
          endedAt,
        },
      },
      { orgId },
    );
  }

  return {
    getDailyRecord,
    sendDeleteDownloadRequest,
    sendGetPlaybackRecordsRequest,
  };
}
